import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Rodeo } from '../../../model/rodeo';
import { ModalController, ToastController, AlertController, LoadingController, Events, PopoverController } from 'ionic-angular';
import { AlertMessager } from '../../../lib/alertMessager';
import { EntryService } from '../../../services/entry.service';
import { RequestService } from '../../../services/request.service';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { Organization } from '../../../model/organization';
import { SearchComponent } from '../../search/search.component';
import { SearchOptions } from '../../../model/searchOptions';
import { RodeoService } from '../../../services/rodeo.service';
import { ChangeRequestDetailsComponent } from './change-request-details';
import { ChangeRequestHelper, ChangeRequestStatus } from '../../../model/registration-change-request';
import { UserSearchPopover } from '../../../pages/search/user-search';
import { Account } from '../../../model/account';
import { RodeoEventService } from '../../../services/rodeoEvent.service';

@Component({
    selector: 'change-request-list',
    templateUrl: 'change-request-list.html'
})
export class ChangeRequestListPage {
    @Output() pendingCountUpdated = new EventEmitter<number>();

    @Input('organization') _organization;
    @Input('rodeo') _rodeo;

    _viewMode: string = 'overview';

    /* 
        DATA
    */
    entryList: any[] = [];
    rodeoList: any[] = [];

    totalSearchResults: number;

    _organizations: any[] = [];

    popoverActive: boolean;
    loadingData: boolean;
    dataLoaded: boolean = false;

    organizationRequests: any[] = [];


    accountMap: Map<number, any> = new Map<number, any>();
    
    requestEntry: any;
    requestRodeo: any;
    
    /*
        FILTERS
    */
    
    searchOptions: SearchOptions = new SearchOptions();
    
    rodeoFilter: string = 'All';
    
    searchChangeObservable;
    searchQuery: string;
    searchResults: any = [];

    requestSearchChangeObservable;
    requestResults: any = [];
    firstName: string;
    lastName: string;

    selectedRequest: any;
    selectedStatus: number | null = null;
    selectedRodeos: Rodeo[] = [];
    selectedClasses: any[] = [];

    selectedContestant: Account;
    contestantName: string = '';

    fromDate: string = '';
    toDate: string = '';

    statuses: any[] = [
        {id: 0, name: 'Pending'},
        {id: 1, name: 'Under Review'},
        {id: 2, name: 'Approved Pending Pay'},
        {id: 3, name: 'Completed'},
        {id: 4, name: 'Denied'},
        {id: 5, name: 'Cancelled'},
        {id: 6, name: 'Error Applying Changes'},
        {id: 7, name: 'Reversed'},
    ]

    /*
        CONSTRUCTORS
    */
    hideM = false;
    hideL = false;
    hideXL = false;

    /*
        SORTING
    */
    sortVariables = [
        {name: 'first', ascending: false },
        {name: 'last', ascending: true },
        {name: 'confirmation', ascending: false },
        {name: 'rodeo', ascending: false },
        {name: 'status', ascending: false },
        {name: 'date', ascending: false }
    ]

    
    /*
        METHODS
    */
    @Input()
    set organization(organization: Organization) {
        console.log('organization', organization);
        if (organization != null) {
            this._organization = organization;

            this.searchOptions.organizations.push(this._organization);
            this.searchOptions.staffSearch = true;
            
            this.loadOrganizationRequests();
            this.checkScreenSize();
        }
    }

    @Input()
    set rodeo(rodeo: Rodeo) {
        console.log('rodeo', rodeo);
        if (rodeo != null) {
            this._rodeo = rodeo;
        }
    }

    get rodeo(): Rodeo {
        return this._rodeo;
      }

    @Input()
    set viewMode(viewMode: string) {
        if (viewMode != null) {
            this._viewMode = viewMode;
        }
    }
    get viewMode(): string {
        return this._viewMode;
    }

    constructor(
        private modalCtrl: ModalController,
        private alertController: AlertController,
        private alert: AlertMessager,
        private loadingController: LoadingController,
        private entryService: EntryService,
        private requestService: RequestService,
        private toast: ToastController,
        private popoverController: PopoverController,
        // private paymentService: PaymentService,
        public events: Events,
        private rodeoService: RodeoService,
        // private userService: UserService,
        private rodeoEventService: RodeoEventService) { }


    getSearchMessage() {
        if (this.loadingData)
            return "";

        if (this.searchQuery == undefined || this.searchQuery.trim().length == 0)
            return "";
        else if (this.searchResults == undefined || this.searchResults.length < 1) {
            return "There are no users entered into this rodeo by that name.";
        }

        return "";
    }
    
    openContestantSearch(searchEvent) {
        let callback = (data) => {
            console.log('user search data', data);
            if (data && data.buddies && data.buddies.length > 0 && data.buddies[0] !== undefined) {
                this.selectedContestant = data.buddies[0];
                this.contestantName = this.selectedContestant.firstName + ' ' + this.selectedContestant.lastName;
            }
        }

        this.userSearch(searchEvent, 'User Search', callback);
    }

    userSearch(searchEvent, title, callback, allowDraw = false, allowTba = false) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: title,
            organization: this.organization,
            allowDraw: allowDraw,
            allowTba: allowTba,
        }, { cssClass: 'user-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            callback(data);
        })
    }

    openRodeoSearch(searchEvent) {
        let callback = (data) => {
            if (data) {
                console.log('rodeo search data', data);
                //TODO: set selected rodeos from search
            }
        }

        this.rodeoSearch(searchEvent, 'Rodeo Search', callback);
    }

    rodeoSearch(searchEvent, title, callback, allowDraw = false, allowTba = false) {
        console.log('search rodeos');

            if (this.popoverActive)
                return;
    
            this.popoverActive = true;
    
        let popover = this.popoverController.create(SearchComponent, {
            config: {
                searchTitle: title,
                horseSearch: false,
                breederSearch: false,
                userSearch: false,
                ownerSearch: false,
                addNew: false,
                rodeoSearch: true,
            },
            rodeoSearchList: this.rodeoList,
               
            }, { cssClass: 'user-search' });
    
            popover.present();
    
            popover.onDidDismiss((data) => {
                this.popoverActive = false;
    
                callback(data);
            })
    }

    async loadOrganizationRequests() {
        let hasNoRodeo = this._rodeo === undefined;

        let loading = hasNoRodeo ? await this.loadingController.create({
            content: 'Loading Requests...',
        }) : undefined;

        if (hasNoRodeo) await loading.present();
       
        try {
            // Has 'organization' and 'staffSearch' ... may need to limit how many due to load
            const rodeos: any = await this.rodeoService.searchRodeos(this.searchOptions);
            
            if (rodeos) {
                this.rodeoList = rodeos;
            }

            if (this._rodeo) {
                this.rodeoList = this.rodeoList.filter(x => x.id === this._rodeo.id);
                this.selectedRodeos.push(this.rodeoList[0]);
                this.searchOptions.rodeos.push(this.rodeoList[0]);
            }

            // console.log(this.searchOptions);
            const orgRequests: any = await this.requestService.searchRequests(this.searchOptions);
                
            if (orgRequests) {
                // console.log('requestResults', orgRequests);
                this.requestResults = orgRequests;
                this.searchResults = orgRequests;
                this.totalSearchResults = orgRequests.length;
                this.pendingCountUpdated.emit(orgRequests.filter(x => x.status === ChangeRequestStatus.Pending).length);
            }
        } catch (err) {
            console.log('ERROR:', err.message || err.errorMessage || err);
            if (hasNoRodeo) await loading.dismiss();
        } finally {
            this.dataLoaded = true;
            if (hasNoRodeo) await loading.dismiss();
        }
    }

    toggleSort(value: string) {
        const sort = this.sortVariables.find((x) => x.name === value);
        this.sortEntries(sort);
    }
    
    private sortEntries(sortValue: any): void {
        this.sortVariables.forEach((x) => { if (x.name !== sortValue.name) { x.ascending = false; } });
        sortValue.ascending = !sortValue.ascending;
        console.log('sort value', sortValue);
    
        const compareValues = (a: any, b: any, ascending: boolean) => {
        if (a < b) return ascending ? -1 : 1;
        if (a > b) return ascending ? 1 : -1;
        return 0;
        };
    
        this.searchResults = this.searchResults.sort((n1, n2) => {
        let result = 0;
    
        switch (sortValue.name) {
            case 'first':
            result = compareValues(
                n1.registration.contestantOne.firstName,
                n2.registration.contestantOne.firstName,
                sortValue.ascending
            );
            break;
            case 'last':
            result = compareValues(
                n1.registration.contestantOne.lastName,
                n2.registration.contestantOne.lastName,
                sortValue.ascending
            );
            break;
            case 'rodeo':
            const n1Rodeo = this.rodeoList.find((x) => x.id === n1.rodeoId).name.toLowerCase();
            const n2Rodeo = this.rodeoList.find((x) => x.id === n2.rodeoId).name.toLowerCase();
            result = compareValues(n1Rodeo, n2Rodeo, sortValue.ascending);
            break;
            case 'confirmation':
            result = compareValues(
                n1.registration.confirmationCode,
                n2.registration.confirmationCode,
                sortValue.ascending
            );
            break;
            case 'status':
            result = compareValues(n1.status, n2.status, sortValue.ascending);
            break;
            case 'date':
            result = compareValues(n1.createdOn, n2.createdOn, sortValue.ascending);
            break;
        }
    
        return result;
        });
    }

    async filterRequests() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        this.dataLoaded = false;

        const loader = this.loadingController.create({
            content: ("Filtering requests...")
        });

        loader.present();

        // reset to original loaded results
        this.searchResults = [];

        this.searchOptions.fromDate = this.fromDate;
        this.searchOptions.toDate = this.toDate;
        this.searchOptions.rodeos = this.selectedRodeos;
        this.searchOptions.requestedById = this.selectedContestant ? this.selectedContestant.id : null;
        this.searchOptions.status = ChangeRequestStatus[this.selectedStatus];
        console.log('search options', this.searchOptions);

        const newResults: any = await this.requestService.searchRequests(this.searchOptions);

        if (newResults) {
            this.searchResults = newResults;
            this.totalSearchResults = newResults.length;
        }

        // console.log('search results', this.searchResults);
        this.dataLoaded = true;
        this.popoverActive = false;

        loader.dismiss();
    }

    async editRequest(request: any) {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        const loader = this.loadingController.create({
            content: ("Retrieving request data...")
        });

        loader.present();

        var requestToEdit = JSON.parse(JSON.stringify(request));

        let rodeo = this.rodeoList.find(x => x.id === request.rodeoId);

        if (rodeo.rodeoEvents.length === 0) {
            rodeo.rodeoEvents = await this.rodeoEventService.getAllForRodeo(rodeo.id);
        }

        const existingRequest: any = await this.requestService.getRequest(requestToEdit.id);
        // console.log('existing request', existingRequest);
        const requestEntry: any = await this.entryService.getEntry(existingRequest.registrationId);
        // console.log('request entry', requestEntry);

        loader.dismiss();

        let requestModal = this.modalCtrl.create(ChangeRequestDetailsComponent, {
                    changeRequest: existingRequest,
                    entry: requestEntry,
                    run: requestEntry.runs.length > 0 ? requestEntry.runs[0] : undefined,
                    rodeo: rodeo,
                    rodeoEvent: rodeo.rodeoEvents.find(x => x.id === existingRequest.registration.rodeoEventId),
                    organization: this._organization,
                    isEditing: true,
                },{ cssClass: 'page-entry-logs', enableBackdropDismiss: false });

        requestModal.present();
        requestModal.onDidDismiss((data) => {
            // console.log('model closed data in organization', data);
            this.popoverActive = false;

            if (data && data.didSave) {
                for (let i = 0; i < this.searchResults.length; i++) {
                    if (this.searchResults[i].id == data.request.id) {
                        Object.assign(this.searchResults[i], data.request);
                        break;
                    }
                }

                for (let i = 0; i < this.requestResults.length; i++) {
                    if (this.requestResults[i].id == data.request.id) {
                        Object.assign(this.requestResults[i], data.request);
                        break;
                    }
                }

                this.pendingCountUpdated.emit(this.searchResults.filter(x => x.status === ChangeRequestStatus.Pending).length);
            }
        });
    }

    getRequestStatusLabel(request) {
        let status = ChangeRequestStatus[request.status];

        if (status === 'ApprovedPendingPayment') {
            status = 'Approved';
        }

        status = status.replace(/([A-Z])/g, ' $1');
        if (request.status == ChangeRequestStatus.Pending) {
            status += request.isTurnoutRequest ? ' - TURNOUT' : ' - CHANGE'
        }
        return status;
    }

    getStatusLabelColor(request) {
        switch(request.status) {
            case ChangeRequestStatus.Completed:
            case ChangeRequestStatus.ApprovedPendingPayment:
                return 'secondary';
            default:
                return 'danger';
        }
    }

    getRequestRodeo(rodeoId: number) {
        const rodeo = this.rodeoList.find(x => x.id === rodeoId);
        if (rodeo) {
            return rodeo.name;
        } else {
            return '--';
        }
    }

    resetFilters() {
        this.selectedRodeos = this._rodeo ? [this.rodeoList[0]] : [];
        this.fromDate = '';
        this.toDate = '';
        this.selectedContestant = undefined;
        this.contestantName = '';
        this.selectedStatus = null;

        this.searchOptions.fromDate = null;
        this.searchOptions.toDate = null;
        this.searchOptions.rodeos = this._rodeo ? [this.rodeoList[0]] : [];
        this.searchOptions.requestedById = null;
        this.searchOptions.status = null;

        this.searchResults = this.requestResults;
        this.totalSearchResults = this.searchResults.length;
    }

    noFiltersSelected() {
        if( this.selectedRodeos.length === 0 && this.fromDate === '' && this.toDate === '' &&
            this.selectedContestant === undefined && this.selectedStatus === null)
        {
            return true;
        } else {
            return false;
        }
    }

    private  checkScreenSize() {
        const screenWidth = window.innerWidth;
        this.hideM = screenWidth < 768;
        this.hideL = screenWidth < 992;
        this.hideXL = screenWidth < 1200;
      }
}




// WEBPACK FOOTER //
// ./src/pages/staff/change-requests/change-request-list.ts